/**
 * Map provider configuration
 * Currently supports MapLibre with Mapbox stub for future expansion
 */

export type MapProvider = "maplibre" | "mapbox";

export const MAP_PROVIDER: MapProvider =
  (import.meta.env.VITE_MAP_PROVIDER as MapProvider) || "maplibre";

// OpenStreetMap tile style - light, clean look
export const MAPLIBRE_STYLE_URL =
  "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";

// Sweden center coordinates (roughly middle of the country)
export const DEFAULT_CENTER: [number, number] = [15.5, 62.0];
export const DEFAULT_ZOOM = 4.5;

// Zoom levels for different contexts
export const NEAR_ME_ZOOM = 11;
export const PLACE_FOCUS_ZOOM = 13;

// Radius options in kilometers
export const RADIUS_OPTIONS = [5, 10, 25] as const;
export type RadiusKm = (typeof RADIUS_OPTIONS)[number];
export const DEFAULT_RADIUS: RadiusKm = 10;
